import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { format } from 'date-fns';
import DoctorDelinquentReportsTable from './DoctorDelinquentReportsTable.vue';
import BaseDateTimePicker from '../base/BaseDateTimePicker.vue';
export default {
  name: 'DoctorDelinquentReports',
  components: {
    DoctorDelinquentReportsTable,
    BaseDateTimePicker
  },
  data() {
    return {
      dateRange: {
        start: null,
        end: null
      },
      isExporting: false,
      category: 'today'
    };
  },
  computed: {
    dateRangeLabel() {
      if (!this.dateRange.start || !this.dateRange.end) {
        return 'Select Date Range';
      }
      const start = new Date(this.dateRange.start).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
      const end = new Date(this.dateRange.end).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
      return `${start} - ${end}`;
    },
    reportDescription() {
      if (this.category === 'today') {
        return `Daily Report as of: ${format(new Date(), 'MM/dd/yy h:mm a')}`;
      }
      if (!this.dateRange.start || !this.dateRange.end) {
        return '';
      }
      return `Averages computed from ${new Date(this.dateRange.start).toLocaleDateString()} - ${new Date(this.dateRange.end).toLocaleDateString()}`;
    }
  },
  methods: {
    selectToday() {
      if (this.category === 'today') {
        return;
      }
      this.category = 'today';
      this.dateRange = {
        start: null,
        end: null
      };
    },
    selectCustomRange() {
      if (this.category === 'custom') {
        return;
      }
      this.category = 'custom';
      this.dateRange = {
        start: null,
        end: null
      };
    },
    async applyDateRange() {
      try {
        await this.$refs.table.getDelinquentReports();
      } catch (error) {
        console.error('Failed to fetch delinquent reports:', error);
        this.$bvToast.toast('Failed to load reports. Please try again.', {
          title: 'Error',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          solid: true
        });
      }
    },
    exportToCSV() {
      this.isExporting = true;
      try {
        const items = this.$refs.table.items;
        if (!items || items.length === 0) {
          this.$bvToast.toast('No data available to export.', {
            title: 'Info',
            variant: 'info',
            toaster: 'b-toaster-top-center',
            solid: true
          });
          this.isExporting = false;
          return;
        }
        const headers = ['Doctor Name', 'Average Total Delinquent', 'Average Messages', 'Average Follow-ups', 'Oldest Pending Task'];
        const rows = items.map(item => [`Dr. ${item.firstname} ${item.lastname}`, item.averagetotaldelinquent, item.averagemessages, item.averagefollowups, item.oldestpendingtask]);
        const csvContent = [headers.join(','), ...rows.map(row => row.map(cell => {
          const cellStr = String(cell);
          if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
            return `"${cellStr.replace(/"/g, '""')}"`;
          }
          return cellStr;
        }).join(','))].join('\n');
        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;'
        });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        let dateStr;
        if (this.category === 'today') {
          dateStr = format(new Date(), 'yyyy-MM-dd');
        } else {
          if (!this.dateRange.start || !this.dateRange.end) {
            dateStr = 'custom_range';
          } else {
            dateStr = `${format(new Date(this.dateRange.start), 'yyyy-MM-dd')}_to_${format(new Date(this.dateRange.end), 'yyyy-MM-dd')}`;
          }
        }
        link.setAttribute('href', url);
        link.setAttribute('download', `doctor_delinquent_reports_${dateStr}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        this.$bvToast.toast('Data exported successfully!', {
          title: 'Success',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          solid: true
        });
      } catch (error) {
        console.error('Export failed:', error);
        this.$bvToast.toast('Failed to export data. Please try again.', {
          title: 'Error',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          solid: true
        });
      } finally {
        this.isExporting = false;
      }
    }
  }
};